import type { ApiModuleEndpoints } from '../types'

export const salesInvoiceApiEndpoints = {
  productOptions: { method: 'GET', path: '/sales/products/options', requiresAuth: true },
  invoices: { method: 'GET', path: '/sales/invoices', requiresAuth: true },
  myInvoices: { method: 'GET', path: '/sales/invoices/mine', requiresAuth: true },
  myInvoiceDetail: { method: 'GET', path: '/sales/invoices/mine/:id', requiresAuth: true },
  createInvoice: { method: 'POST', path: '/sales/invoices', requiresAuth: true },
  invoiceDetail: { method: 'GET', path: '/sales/invoices/:id', requiresAuth: true },
  updateInvoice: { method: 'PUT', path: '/sales/invoices/:id', requiresAuth: true },
  completeInvoice: { method: 'POST', path: '/sales/invoices/:id/complete', requiresAuth: true },
  cancelInvoice: { method: 'POST', path: '/sales/invoices/:id/cancel', requiresAuth: true },
  payShipping: { method: 'POST', path: '/sales/invoices/:id/pay-shipping', requiresAuth: true },
  deleteInvoice: { method: 'DELETE', path: '/sales/invoices/:id', requiresAuth: true },
} as const satisfies ApiModuleEndpoints
